<template>
    <div role="tabcard" class="tab-pane" id="dashboard">
        <div class="card card-default">
            <div class="card-header">Dashboard</div>

            <div class="card-body">
                Your application's dashboard.
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        created: function() {

        },

        mounted: function() {

        },

        data: function() {
            return {
            };
        },

        computed: {
            
        },

        methods: {
           
        }
    }
</script>
